import { registerThemeSpec } from '@xhs/yam-beer/core/system/utils/themeSpec'
import { composeStyle } from '@xhs/yam-beer/core/system/compose'
import { StepStatus } from '@xhs/yam-beer/cmp/constants'

export default function initStyle() {
  return [
    registerThemeSpec('cmp.steps.container', {
      display: 'flex',
      bg: 'white',
    }),
    registerThemeSpec('cmp.steps.number', {
      connector: {
        flex: '1 1 0',
        height: '2px',
        mt: 15,
        mx: '-35px',
        bg: 'palette.grey3.base',
        '&[data-active]': {
          bg: 'brand',
        },
      },
      wrapper: {
        width: 144,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      },
      circle: {
        mb: '2x',
        size: 32,
        borderRadius: 'circle',
        borderWidth: '2px',
        borderStyle: 'solid',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '16px',
        fontWeight: 'medium',
        '&.click-able': {
          cursor: 'pointer',
        },
      },
      circleStatus: composeStyle.switch('status')
        .case(StepStatus.DONE, {
          borderColor: 'brand',
          svg: {
            fill: 'brand',
          },
        })
        .case(StepStatus.PROGRESS, {
          bg: 'brand',
          borderColor: 'brand',
          color: 'white',
          svg: {
            fill: 'white',
          },
        })
        .case(StepStatus.FAILED, {
          borderColor: 'danger',
          svg: {
            fill: 'danger',
          },
        })
        .default({
          borderColor: 'outline',
          color: 'outline',
          svg: {
            fill: 'outline',
          },
          '&.click-able': {
            '&:hover': {
              color: 'brand',
              borderColor: 'brand',
            },
          },
        }),
      title: {
        mb: 12,
        fontSize: '14px',
        lineHeight: '14px',
        fontWeight: 'medium',
        display: 'flex',
        alignItems: 'center',
        color: composeStyle.switch('status')
          .case(StepStatus.FAILED, 'danger')
          .case(StepStatus.PENDING, 'ash')
          .default('body'),
      },
      content: {
        fontSize: '12px',
        lineHeight: '18px',
        color: composeStyle.switch('status')
          .case(StepStatus.FAILED, 'danger')
          .case(StepStatus.PENDING, 'ash')
          .default('mute'),
      },
    }),
  ]
}
